import axios from "axios";
import { base_url } from "../../utils/axiosConfig";

// Fetch Categories List
const categorylist = async () => {
  const response = await axios.get(`${base_url}pcategory`);
  if (response.data) {
    return response.data; // Return the response as is (array of categories)
  }
};

// Fetch Category and Subcategory List
const categoryandsublist = async (category, subCategory) => {
  const response = await axios.get(`${base_url}Products/products/${category}/${subCategory}`);

  
  if (response.data) {
    return Array.isArray(response.data) ? response.data : response.data.products || [];
  }
};

export const catservice = {
  categorylist,
  categoryandsublist,
};
